import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { objectToQueryString } from '../../../../utils/queryHelper';
import { MarketplaceBuyer } from '../models/buyer';

export const GetBuyer = createAsyncThunk(
    'marketplaceBuyers/getBuyer',
    async (params: { buyerId: number | null; includeLoiForm?: boolean }, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.get(
                `/api/Marketplace/MarketplaceBuyers?${objectToQueryString({
                    buyerId: params.buyerId,
                    ...(params.includeLoiForm ? { includeLoiForm: true } : {}),
                })}`
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not fetch profile at the moment.',
                    'error'
                );
                throw new Error('Failed to fetch profile');
            }

            return {
                buyer: response.data as MarketplaceBuyer,
            };
        } catch (error) {
            createNotification(
                'An error occurred while fetching profile.',
                'error'
            );
            throw error;
        }
    }
);
